import NotFoundPage from "../../../features/fallbacks/NotFoundPage";
import { Outlet } from "react-router-dom";
import HelpCenterPage from "../pages/HelpCenterPage";
import ProductTourRedirectPage from "../pages/ProductTourRedirectPage";
import HelpCenterArticlesPage from "../pages/HelpCenterArticlesPage";
import { HelpCardContent } from "../components/HelpCenter.config";
import HelpCenterContactPage from "../pages/HelpCenterContactPage";

export const SupportRoutes = [
  {
    path: "/",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <HelpCenterPage />,
      },
      {
        path: `product-tour`,
        element: <ProductTourRedirectPage />,
      },
      // {
      //   path: "managing-account",
      //   element: (
      //     <HelpCenterArticlesPage
      //       title={HelpCardContent[0].Title}
      //       articles={HelpCardContent[0].subtitles}
      //     />
      //   ),
      // },
      // {
      //   path: "safety-and-security",
      //   element: (
      //     <HelpCenterArticlesPage
      //       title={HelpCardContent[1].Title}
      //       articles={HelpCardContent[1].subtitles}
      //     />
      //   ),
      // },
      {
        path: "data-connectors",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: (
              <HelpCenterArticlesPage
                title={HelpCardContent[0].Title}
                articles={HelpCardContent[0].subtitles}
              />
            ),
          },
          {
            path: "trello",
            element: HelpCardContent[0].subtitles[0].content,
          },
          {
            path: "jira",
            element: HelpCardContent[0].subtitles[1].content,
          },
          {
            path: "slack",
            element: HelpCardContent[0].subtitles[2].content,
          },
          {
            path: "google-drive",
            element: HelpCardContent[0].subtitles[3].content,
          },
        ],
      },
      // {
      //   path: "using-onegate",
      //   element: (
      //     <HelpCenterArticlesPage
      //       title={HelpCardContent[3].Title}
      //       articles={HelpCardContent[3].subtitles}
      //     />
      //   ),
      // },
      // {
      //   path: "rules-and-policy",
      //   element: (
      //     <HelpCenterArticlesPage
      //       title={HelpCardContent[4].Title}
      //       articles={HelpCardContent[4].subtitles}
      //     />
      //   ),
      // },
      {
        path: "smart-search",
        element: (
          <HelpCenterArticlesPage
            title={HelpCardContent[1].Title}
            articles={HelpCardContent[1].subtitles}
          />
        ),
      },
      {
        path: "contact-us",
        element: <HelpCenterContactPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];
